import React, { useState } from "react";
import { faqs } from "./mockup";
import { IoIosArrowDown } from "react-icons/io";
import { FiHelpCircle, FiSearch } from "react-icons/fi";

export const LandingFAQs: React.FC = () => {
  const [answersShow, setAnswersShow] = useState<boolean[]>(
    Array.from({ length: faqs.length }, () => false)
  );
  const [searchQuery, setSearchQuery] = useState("");

  const handleToggle = (index: number) => {
    const newList = [...answersShow];
    newList[index] = !newList[index];
    setAnswersShow(newList);
  };

  const filteredFaqs = faqs.map((faq, originalIndex) => ({
    ...faq,
    originalIndex,
  })).filter(({ Q, A }) => {
    if (!searchQuery.trim()) return true;
    const query = searchQuery.toLowerCase();
    return Q.toLowerCase().includes(query) || A.toLowerCase().includes(query);
  });

  return (
    <div id="FAQs" className="py-20 bg-white relative overflow-hidden">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12">
        
        {/* FAQ Header */}
        <div className="text-center space-y-4 max-w-2xl mx-auto" data-aos="fade-up">
          <span className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-blue-50 text-blue-600 text-xs font-black uppercase tracking-widest border border-blue-100">
            <FiHelpCircle size={14} /> Got Questions?
          </span>
          <h2 className="text-3xl sm:text-5xl font-black text-slate-900 tracking-tight">
            Frequently Asked Questions
          </h2>
          <p className="text-sm text-slate-600 font-medium">
            Everything you need to know about setting up and using Pendulum Digital at your school.
          </p>

          {/* Quick Search */}
          <div className="pt-2 max-w-md mx-auto relative flex items-center">
            <FiSearch className="absolute left-4 text-slate-400" size={18} />
            <input
              type="text"
              placeholder="Search questions or keywords..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full bg-slate-50 border border-slate-200 rounded-2xl pl-11 pr-4 py-3 text-xs font-bold text-slate-800 placeholder:text-slate-400 outline-none focus:border-blue-500 focus:bg-white transition-all shadow-sm"
            />
          </div>
        </div>

        {/* Accordions List */}
        <div className="space-y-4">
          {filteredFaqs.length === 0 ? (
            <div className="p-12 text-center bg-slate-50 rounded-3xl border border-dashed border-slate-200 text-xs font-medium text-slate-400">
              No questions found matching "{searchQuery}".
            </div>
          ) : (
            filteredFaqs.map(({ Q, A, originalIndex }, idx) => {
              const isOpen = answersShow[originalIndex];
              return (
                <div
                  key={originalIndex}
                  data-aos="fade-up"
                  data-aos-delay={idx * 50}
                  className={`rounded-2xl border transition-all duration-200 overflow-hidden ${
                    isOpen
                      ? "bg-blue-50/40 border-blue-200 shadow-md ring-1 ring-blue-100"
                      : "bg-slate-50/70 border-slate-200/80 hover:bg-slate-50"
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => handleToggle(originalIndex)}
                    className="w-full p-5 sm:p-6 text-left flex justify-between items-center gap-4 outline-none"
                  >
                    <span className="font-black text-sm sm:text-base text-slate-800 flex items-center gap-3">
                      <span className="w-7 h-7 rounded-xl bg-blue-100 text-blue-700 text-xs flex items-center justify-center font-black shrink-0">
                        Q{idx + 1}
                      </span>
                      {Q}
                    </span>
                    <div className={`w-8 h-8 rounded-xl flex items-center justify-center transition-transform duration-300 shrink-0 ${
                      isOpen ? "bg-blue-600 text-white rotate-180" : "bg-slate-200 text-slate-600"
                    }`}>
                      <IoIosArrowDown size={18} />
                    </div>
                  </button>

                  {isOpen && (
                    <div className="px-5 pb-6 sm:px-6 sm:pb-6 pt-1 text-xs sm:text-sm text-slate-600 font-normal leading-relaxed border-t border-blue-100/60 animate-in fade-in duration-200">
                      <div className="bg-white p-4 rounded-xl border border-slate-100 text-slate-700">
                        {A}
                      </div>
                    </div>
                  )}
                </div>
              );
            })
          )}
        </div>

      </div>
    </div>
  );
};

export default LandingFAQs;
